'use client'

import {
  ClientPortfolioProps,
  ClientPortFolioSection,
  type ClientPortfolioSectionData,
} from '../ClientPortFolioSection'

export type TestimonialSectionData = ClientPortfolioSectionData
type TestimonialSectionProps = ClientPortfolioProps

export function TestimonialSection(data: TestimonialSectionProps) {
  return <ClientPortFolioSection {...data} />
}
